/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedDescriptionAboutCreator_item$ref: FragmentReference;
export type PdpSharedDescriptionAboutCreator_item = {|
  +creatorContent: ?{|
    +name: ?string,
    +description: ?string,
    +role: ?string,
  |},
  +$refType: PdpSharedDescriptionAboutCreator_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedDescriptionAboutCreator_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creatorContent",
      "storageKey": null,
      "args": null,
      "concreteType": "BrowseContentModule",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "role",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '80b135fbbdcde8f2c76aa0cb5c91776b';
module.exports = node;
